module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleC2.2de11124.png";